import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { cn } from "@repo/share-log-web-utils";
import type { NameValue, DetailItem } from "../chart-styles";
import {
  tooltipContentStyle,
  tooltipItemStyle,
  formatKRW,
  GROUPED_COLOR,
} from "../chart-styles";

const PIE_CHART_HEIGHT_PX = 220;
const PIE_OUTER_RADIUS = 90;

interface PieWithDetailListProps {
  pieData: NameValue[];
  detailItems: DetailItem[];
  colors: string[];
}

export function PieWithDetailList({
  pieData,
  detailItems,
  colors,
}: PieWithDetailListProps) {
  return (
    <div>
      <ResponsiveContainer width="100%" height={PIE_CHART_HEIGHT_PX}>
        <PieChart>
          <Pie
            data={pieData}
            cx="50%"
            cy="50%"
            outerRadius={PIE_OUTER_RADIUS}
            dataKey="value"
            nameKey="name"
            label={false}
            labelLine={false}
          >
            {pieData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={
                  entry.name === "기타"
                    ? GROUPED_COLOR
                    : colors[index % colors.length]
                }
              />
            ))}
          </Pie>
          <Tooltip
            formatter={formatKRW}
            contentStyle={tooltipContentStyle}
            itemStyle={tooltipItemStyle}
          />
        </PieChart>
      </ResponsiveContainer>

      <div className="mt-2 space-y-1 px-1">
        {detailItems.map((item) => (
          <div key={item.name} className="flex items-center gap-2 py-0.5">
            <span
              className="h-2.5 w-2.5 shrink-0 rounded-full"
              style={{ backgroundColor: item.color }}
            />
            <span
              className={cn(
                "flex-1 truncate text-sm",
                item.isGrouped ? "text-muted-foreground" : "text-foreground",
              )}
            >
              {item.name}
            </span>
            <span className="shrink-0 tabular-nums text-sm text-muted-foreground">
              {item.percent.toFixed(1)}%
            </span>
            <span className="shrink-0 tabular-nums text-sm text-muted-foreground">
              {formatKRW(item.value)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
